import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';
import clsx from 'clsx';
import styles from './BackHeader.module.css';

export default function BackHeader({
  label = 'Header Label',
  onClick,
  className,
  iconSize,
  labelSize,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={clsx(styles.backHeader, className)} onClick={handleClick}>
      <IoIosArrowBack className={styles.icon} style={{ fontSize: iconSize }} />
      <span className={styles.label} style={{ fontSize: labelSize }}>
        {label}
      </span>
    </div>
  );
}
